import { render, staticRenderFns } from "./CessaoDireitos.vue?vue&type=template&id=aa29abaa&"
import script from "./CessaoDireitos.vue?vue&type=script&lang=js&"
export * from "./CessaoDireitos.vue?vue&type=script&lang=js&"
import style0 from "./CessaoDireitos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports